<div class="container">
  <mat-label *ngIf="label" class="label">{{label}}</mat-label>
  <mat-form-field appearance="outline" class="w-p-100">
    <mat-label>Select Option</mat-label>
    <mat-select (selectionChange)="sourceOptionChange($event)">
      <mat-option *ngFor="let option of sourceOptions" [value]="option">
        {{option.value}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field *ngIf="sourceOption && sourceOption.id === 'itp-fields'" appearance="outline" class="w-p-100">
    <mat-label>{{label ? label : 'Select Source'}}</mat-label>
    <mat-select (selectionChange)="onSourceSelectionChange($event)" [value]="selectedSource">
      <mat-option *ngFor="let sourceApiMapping of sourceApiMappings"
                  [value]="sourceApiMapping">{{sourceApiMapping.title}}</mat-option>
    </mat-select>
  </mat-form-field>

  <div *ngIf="sourceOption && sourceOption.id === 'questionnaire' && (questionnaireNameDisplayText || selectedItems)"
       class="m-b-8 flex flex-row justify-start items-center">
    <strong class="m-r-8">Selected Questionnaire</strong>
    <span class="link-button">
       {{questionnaireNameDisplayText}}
    </span>
  </div>
</div>
